"use strict";
import PhotoSwipe from "photoswipe";

let source = [];

function setSource(id) {
  source = [];
  for (let i = 0; i < window.dataImage.length; i++) {
    if (window.dataImage[i].order == id) {
      let videos = window.dataImage[i].files;
      let arrVideos = videos.slice(2);
      for (let j = 0; j < arrVideos.length; j++) {
        if(arrVideos[j].type == "image"){
          source.push({
            src: arrVideos[j].mediaCollection["thumbnail_1920x1080"],
            width: 1920,
            height: 1080,
            alt: arrVideos[j].title
          });
        } else if(arrVideos[j].type == "video"){
          source.push({
            html: `<video class="video-photoswipe" controls autoplay><source src="${arrVideos[j].fullUrl}" type="${arrVideos[j].mime_type}"></video>`,
            isVideo: true
          });
        } else if(arrVideos[j].type == "link"){
          source.push({
            html: `<iframe class="youtube-photoswipe" src="${arrVideos[j].youtubeLink}" frameborder="0"></iframe>`,
            isVideo: true
          });
        }
      }
    }
  }

  return source;
}

$(".gallery").on("click", function() {
  let id = $(this).data("id");
  id = id.replace("my-gallery-", "");

  let randomSource = setSource(id);

  if(randomSource.length >= 1){
    const pswp = new PhotoSwipe({
      dataSource: randomSource,
      showHideAnimationType: "none",
      pswpModule: () => import("photoswipe")
    });

    pswp.init();

    pswp.on("change", function(index) {
      //let data = pswp.options.dataSource;
      const currentItem = pswp.currSlide.data;

      if (currentItem.isVideo) {
        let video = $(currentItem.html)[0];
        video.play();
      }

    });
  }
});

